import { IWalletAddressDto } from 'api/integrations/dtos'

// also values are keys for translations
export enum TransactionType {
	// import mapping types - 17
	CRYPTO_SEND_TO_UNKNOWN = 'Send To Unknown',
	CRYPTO_RECEIVE_NON_TAXABLE = 'Receive (Non Taxable)',
	CRYPTO_TRANSFER = 'Transfer',
	CRYPTO_PURCHASE_FOR_FIAT = 'Buy',
	CRYPTO_SELL_FOR_FIAT = 'Sell',
	CRYPTO_TRADE = 'Trade',
	FIAT_TRADE = 'Trade Fiat',
	FIAT_DEPOSIT = 'Deposit Fiat',
	FIAT_WITHDRAWAL = 'Withdraw Fiat',
	CRYPTO_FORK = 'Fork',
	UNKNOWN = 'Unknown',
	CRYPTO_SEND_PAYMENT = 'Send Payment',
	CRYPTO_RECEIVE_PAYMENT = 'Receive Payment',
	CRYPTO_SEND_GIFT_OR_DONATION = 'Send Gift Or Donation',
	CRYPTO_RECEIVE_GIFT_OR_DONATION = 'Receive Gift Or Donation',
	CRYPTO_AIRDROP = 'Airdrop',
	CRYPTO_MINING = 'Mining',
	// new types - 19
	CRYPTO_LENDING = 'Lending',
	CRYPTO_LENDING_REPAYMENT = 'Repayment (Lending)',
	CRYPTO_MINTED_SELL = 'Minted NFT Sell',
	CRYPTO_LIQUIDITY_POOL_DEPOSIT = 'Liquidity Pool Deposit',
	CRYPTO_LIQUIDITY_POOL_WITHDRAWAL = 'Liquidity Pool Withdrawal',
	CRYPTO_NON_TAXABLE_SWAP = 'Non Taxable Swap',
	CRYPTO_DEBT_REPAYMENT = 'Debt Repayment',
	CRYPTO_EXPENSE = 'Expense',
	CRYPTO_OTHER_FEES = 'Other Fees',
	CRYPTO_LOST_OR_STOLEN = 'Lost Or Stolen',
	CRYPTO_SEND_NON_TAXABLE = 'Send (Non Taxable)',
	CRYPTO_INCOME_REWARD = 'Income / Reward',
	CRYPTO_INTEREST_INCOME = 'Interest Income',
	CRYPTO_STAKING_REWARD = 'Staking Reward',
	CRYPTO_BORROWING = 'Borrowing',
	CRYPTO_ICO_IDO = 'ICO / IDO',
	CURRENCY_MARGIN_PROFIT = 'Margin Profit',
	CURRENCY_MARGIN_LOSS = 'Margin Loss',
	CRYPTO_LIQUIDATION = 'Liquidation',
	CRYPTO_SPAM = 'Spam',
}

export type ExternalCSVTransactionType =
	| 'UNKNOWN'
	| 'BUY'
	| 'SELL'
	| 'TRADE'
	| 'BUY_SELL'
	| 'WITHDRAWAL'
	| 'DEPOSIT'
	| 'WITHDRAWAL_DEPOSIT'
	| 'FORK'
	| 'TRANSFER'
	| 'GIFT'
	| 'SEND'
	| 'RECEIVE'

export type TransactionFlowType = 'IN' | 'OUT' | 'EXCHANGE' | 'UNKNOWN'

export interface ITransactionDto {
	blockChainTransactionId?: string
	effectiveDate: string
	acquisitionDate?: string
	additionalCosts?: number
	feeOriginalAmount?: number
	feeOriginalCurrency?: string
	feePriceInBaseCurrency?: number
	forkBaseCurrency?: string
	feeValuation?: number
	group?: string
	id: string
	inAmount?: number
	inCurrency?: string
	inPriceInBaseCurrency?: number
	inTransactionsSource?: string
	inValuationTotal?: number
	inWallet?: IWalletAddressDto
	integrationId?: string
	integrationName?: string
	needsReview?: {
		needsReviewApproved: boolean
		needsReviewEnums: string[]
	}
	note?: string
	outAmount?: number
	outCurrency?: string
	outPriceInBaseCurrency?: number
	outTransactionsSource?: string
	outValuationTotal?: number
	outWallet?: IWalletAddressDto
	transactionType: TransactionType
	properties: Record<string, string>
	userId: string
	isMarginLossInValue?: boolean
	isMarginProfitInValue?: boolean
	marginLossValue?: number
	marginProfitValue?: number
	wallet?: IWalletAddressDto
	capitalLoss?: number
	flowType: TransactionFlowType

	// string alternatives
	capitalLossString?: string
	additionalCostsString?: string
	marginProfitValueString?: string
	marginLossValueString?: string
	outAmountString?: string
	outValuationTotalString?: string
	outPriceInBaseCurrencyString?: string
	inAmountString?: string
	inValuationTotalString?: string
	inPriceInBaseCurrencyString?: string
	feeValuationString?: string
	feePriceInBaseCurrencyString?: string
	feeOriginalAmountString?: string
}

export interface IGetTransactionListResponse {
	filteredTransactionCount: number
	totalTransactionCount: number
	transactions: ITransactionDto[]
}

export interface ITransactionStatisticDto {
	allTransactions: number
	approvedNeedsReview: number
	dateOfFirstTransaction?: string
	dateOfLastTransaction?: string
	needsReview: number
	transactions: Record<TransactionType, number>
}
